import { assertAdminDataWriteAccess, assertProjectWriteAccess, assertStreamWriteAccess, assertStreamTakerWriteAccess, emptyStudioConfigData, } from "../projects-helpers.js";
export function createStreamingQueries({ defineProjectQuery, projectZql, }) {
    return {
        studios: {
            list: defineProjectQuery(({ ctx }) => {
                if (ctx.role !== "admin" && ctx.role !== "employee") {
                    return projectZql.studios.where("id", "__unauthorized__");
                }
                return projectZql.studios
                    .where("deletedAt", "IS", null)
                    .orderBy("name", "asc");
            }),
            byID: defineProjectQuery(({ args, ctx }) => {
                if (ctx.role !== "admin" && ctx.role !== "employee") {
                    return projectZql.studios.where("id", "__unauthorized__").one();
                }
                return projectZql.studios.where("id", args.id).one();
            }),
        },
        studioConfigs: {
            byStudio: defineProjectQuery(({ args, ctx, }) => {
                if (ctx.role !== "admin" && ctx.role !== "employee") {
                    return projectZql.studioConfigs.where("id", "__unauthorized__");
                }
                return projectZql.studioConfigs
                    .where("studioID", args.studioID)
                    .orderBy("updatedAt", "desc");
            }),
            byID: defineProjectQuery(({ args, ctx }) => {
                if (ctx.role !== "admin" && ctx.role !== "employee") {
                    return projectZql.studioConfigs
                        .where("id", "__unauthorized__")
                        .one();
                }
                return projectZql.studioConfigs.where("id", args.id).one();
            }),
            versions: defineProjectQuery(({ args, ctx, }) => {
                if (ctx.role !== "admin" && ctx.role !== "employee") {
                    return projectZql.studioConfigVersions.where("id", "__unauthorized__");
                }
                return projectZql.studioConfigVersions
                    .where("configID", args.configID)
                    .orderBy("version", "desc");
            }),
        },
        studioConnections: {
            byStudio: defineProjectQuery(({ args, ctx, }) => {
                if (ctx.role !== "admin" && ctx.role !== "employee") {
                    return projectZql.studioConnections.where("id", "__unauthorized__");
                }
                return projectZql.studioConnections
                    .where("studioID", args.studioID)
                    .orderBy("name", "asc");
            }),
        },
        brokers: {
            byStudio: defineProjectQuery(({ args, ctx, }) => {
                if (ctx.role !== "admin" && ctx.role !== "employee") {
                    return projectZql.brokers.where("id", "__unauthorized__");
                }
                return projectZql.brokers
                    .where("studioID", args.studioID)
                    .orderBy("name", "asc");
            }),
            byID: defineProjectQuery(({ args, ctx }) => {
                if (ctx.role !== "admin" && ctx.role !== "employee") {
                    return projectZql.brokers.where("id", "__unauthorized__").one();
                }
                return projectZql.brokers.where("id", args.id).one();
            }),
        },
        brokerOutputs: {
            byBroker: defineProjectQuery(({ args, ctx, }) => {
                if (ctx.role !== "admin" && ctx.role !== "employee") {
                    return projectZql.brokerOutputs.where("id", "__unauthorized__");
                }
                return projectZql.brokerOutputs
                    .where("brokerID", args.brokerID)
                    .orderBy("sortOrder", "asc")
                    .orderBy("name", "asc");
            }),
        },
        profiles: {
            list: defineProjectQuery(({ ctx }) => {
                if (ctx.role !== "admin" && ctx.role !== "employee") {
                    return projectZql.profiles.where("id", "__unauthorized__");
                }
                return projectZql.profiles.orderBy("name", "asc");
            }),
            byID: defineProjectQuery(({ args, ctx }) => {
                if (ctx.role !== "admin" && ctx.role !== "employee") {
                    return projectZql.profiles.where("id", "__unauthorized__").one();
                }
                return projectZql.profiles.where("id", args.id).one();
            }),
        },
        streams: {
            byProject: defineProjectQuery(({ args, ctx, }) => {
                if (ctx.role !== "admin" && ctx.role !== "employee") {
                    return projectZql.streams.where("id", "__unauthorized__");
                }
                return projectZql.streams
                    .where("projectID", args.projectID)
                    .orderBy("name", "asc");
            }),
            byID: defineProjectQuery(({ args, ctx }) => {
                if (ctx.role !== "admin" && ctx.role !== "employee") {
                    return projectZql.streams.where("id", "__unauthorized__").one();
                }
                return projectZql.streams.where("id", args.id).one();
            }),
        },
        streamAudioPairs: {
            byStream: defineProjectQuery(({ args, ctx, }) => {
                if (ctx.role !== "admin" && ctx.role !== "employee") {
                    return projectZql.streamAudioPairs.where("id", "__unauthorized__");
                }
                return projectZql.streamAudioPairs
                    .where("streamID", args.streamID)
                    .orderBy("pairIndex", "asc");
            }),
        },
        streamOutputs: {
            byStream: defineProjectQuery(({ args, ctx, }) => {
                if (ctx.role !== "admin" && ctx.role !== "employee") {
                    return projectZql.streamOutputs.where("id", "__unauthorized__");
                }
                return projectZql.streamOutputs
                    .where("streamID", args.streamID)
                    .orderBy("sortOrder", "asc")
                    .orderBy("name", "asc");
            }),
        },
        streamBrokers: {
            byStream: defineProjectQuery(({ args, ctx, }) => {
                if (ctx.role !== "admin" && ctx.role !== "employee") {
                    return projectZql.streamBrokers.where("id", "__unauthorized__");
                }
                return projectZql.streamBrokers
                    .where("streamID", args.streamID)
                    .related("broker")
                    .orderBy("sortOrder", "asc");
            }),
        },
        projectAwsResourceLinks: {
            list: defineProjectQuery(({ ctx }) => {
                if (ctx.role !== "admin" && ctx.role !== "employee") {
                    return projectZql.projectAwsResourceLinks.where("id", "__unauthorized__");
                }
                return projectZql.projectAwsResourceLinks
                    .orderBy("resourceType", "asc")
                    .orderBy("resourceName", "asc");
            }),
            byProject: defineProjectQuery(({ args, ctx, }) => {
                if (ctx.role !== "admin" && ctx.role !== "employee") {
                    return projectZql.projectAwsResourceLinks.where("id", "__unauthorized__");
                }
                return projectZql.projectAwsResourceLinks
                    .where("projectID", args.projectID)
                    .orderBy("resourceType", "asc")
                    .orderBy("resourceName", "asc");
            }),
        },
        streamAudioFeeds: {
            byProject: defineProjectQuery(({ args, ctx, }) => {
                if (ctx.role !== "admin" && ctx.role !== "employee") {
                    return projectZql.streamAudioFeeds.where("id", "__unauthorized__");
                }
                return projectZql.streamAudioFeeds
                    .where("projectID", args.projectID)
                    .orderBy("sortOrder", "asc")
                    .orderBy("name", "asc");
            }),
        },
        streamVideoFeeds: {
            byProject: defineProjectQuery(({ args, ctx, }) => {
                if (ctx.role !== "admin" && ctx.role !== "employee") {
                    return projectZql.streamVideoFeeds.where("id", "__unauthorized__");
                }
                return projectZql.streamVideoFeeds
                    .where("projectID", args.projectID)
                    .orderBy("sortOrder", "asc")
                    .orderBy("name", "asc");
            }),
        },
        streamSignals: {
            byProject: defineProjectQuery(({ args, ctx, }) => {
                if (ctx.role !== "admin" && ctx.role !== "employee") {
                    return projectZql.streamSignals.where("id", "__unauthorized__");
                }
                return projectZql.streamSignals
                    .where("projectID", args.projectID)
                    .related("videoFeed")
                    .related("audioFeedLinks", (q) => q.related("audioFeed").orderBy("sortOrder", "asc"))
                    .orderBy("sortOrder", "asc");
            }),
        },
        streamTakers: {
            byProject: defineProjectQuery(({ args, ctx, }) => {
                if (ctx.role !== "admin" && ctx.role !== "employee") {
                    return projectZql.streamTakers.where("id", "__unauthorized__");
                }
                return projectZql.streamTakers
                    .where("projectID", args.projectID)
                    .related("signal", (q) => q
                    .related("videoFeed")
                    .related("audioFeedLinks", (q2) => q2.related("audioFeed").orderBy("sortOrder", "asc")))
                    .related("contacts", (q) => q.related("person"))
                    .related("audioPairTests")
                    .orderBy("name", "asc");
            }),
        },
    };
}
export function createStreamingMutators({ defineProjectMutator, projectZql, schemas, }) {
    const { createStudioInputSchema, updateStudioInputSchema, studioIDInputSchema, createStudioConfigInputSchema, updateStudioConfigInputSchema, deleteStudioConfigInputSchema, restoreStudioConfigVersionInputSchema, createStudioConnectionInputSchema, updateStudioConnectionInputSchema, deleteStudioConnectionInputSchema, createBrokerInputSchema, updateBrokerInputSchema, deleteBrokerInputSchema, createBrokerOutputInputSchema, updateBrokerOutputInputSchema, deleteBrokerOutputInputSchema, createProfileInputSchema, updateProfileInputSchema, profileIDInputSchema, createStreamInputSchema, updateStreamInputSchema, deleteStreamInputSchema, createStreamAudioPairInputSchema, deleteStreamAudioPairInputSchema, createStreamOutputInputSchema, updateStreamOutputInputSchema, deleteStreamOutputInputSchema, createStreamBrokerInputSchema, updateStreamBrokerInputSchema, deleteStreamBrokerInputSchema, createProjectAwsResourceLinkInputSchema, updateProjectAwsResourceLinkInputSchema, deleteProjectAwsResourceLinkInputSchema, createStreamAudioFeedInputSchema, deleteStreamAudioFeedInputSchema, updateStreamAudioFeedInputSchema, createStreamVideoFeedInputSchema, deleteStreamVideoFeedInputSchema, updateStreamVideoFeedInputSchema, createStreamSignalInputSchema, deleteStreamSignalInputSchema, updateStreamSignalInputSchema, createStreamSignalAudioFeedInputSchema, updateStreamSignalAudioFeedInputSchema, deleteStreamSignalAudioFeedInputSchema, createStreamTakerInputSchema, updateStreamTakerInputSchema, deleteStreamTakerInputSchema, createStreamTakerAudioPairInputSchema, updateStreamTakerAudioPairInputSchema, deleteStreamTakerAudioPairInputSchema, createStreamTakerContactInputSchema, updateStreamTakerContactInputSchema, deleteStreamTakerContactInputSchema, createStreamTakerAudioPairTestInputSchema, updateStreamTakerAudioPairTestInputSchema, deleteStreamTakerAudioPairTestInputSchema, } = schemas;
    return {
        studios: {
            create: defineProjectMutator(createStudioInputSchema, async ({ tx, ctx, args, }) => {
                assertAdminDataWriteAccess(ctx);
                await tx.mutate.studios.insert({
                    ...args,
                    deletedAt: null,
                });
            }),
            update: defineProjectMutator(updateStudioInputSchema, async ({ tx, ctx, args, }) => {
                assertAdminDataWriteAccess(ctx);
                await tx.mutate.studios.update(args);
            }),
            softDelete: defineProjectMutator(studioIDInputSchema, async ({ tx, ctx, args, }) => {
                assertAdminDataWriteAccess(ctx);
                await tx.mutate.studios.update({
                    id: args.id,
                    deletedAt: Date.now(),
                });
            }),
        },
        studioConfigs: {
            create: defineProjectMutator(createStudioConfigInputSchema, async ({ tx, ctx, args, }) => {
                assertAdminDataWriteAccess(ctx);
                const configData = args.configData ?? emptyStudioConfigData;
                const now = Date.now();
                await tx.mutate.studioConfigs.insert({
                    id: args.id,
                    studioID: args.studioID,
                    projectID: args.projectID ?? null,
                    name: args.name,
                    description: args.description ?? null,
                    version: 1,
                    configData,
                    createdAt: now,
                    updatedAt: now,
                });
                await tx.mutate.studioConfigVersions.insert({
                    id: crypto.randomUUID(),
                    configID: args.id,
                    version: 1,
                    configData,
                    createdAt: now,
                });
            }),
            update: defineProjectMutator(updateStudioConfigInputSchema, async ({ tx, ctx, args, }) => {
                assertAdminDataWriteAccess(ctx);
                const updates = {
                    id: args.id,
                    updatedAt: Date.now(),
                };
                if (args.name !== undefined)
                    updates.name = args.name;
                if (args.description !== undefined) {
                    updates.description = args.description ?? null;
                }
                if (args.configData !== undefined) {
                    updates.configData = args.configData;
                    const latest = await tx.run(projectZql.studioConfigVersions
                        .where("configID", args.id)
                        .orderBy("version", "desc")
                        .limit(1)
                        .one());
                    const versionWindowMs = 5 * 60 * 1000;
                    const latestCreatedAt = typeof latest?.createdAt === "number" ? latest.createdAt : 0;
                    const isRecent = Boolean(latest) && Date.now() - latestCreatedAt < versionWindowMs;
                    if (isRecent) {
                        await tx.mutate.studioConfigVersions.update({
                            id: latest.id,
                            configData: args.configData,
                        });
                    }
                    else {
                        const current = await tx.run(projectZql.studioConfigs.where("id", args.id).one());
                        if (!current)
                            throw new Error("Studio config not found");
                        const newVersion = (current.version ?? 1) + 1;
                        updates.version = newVersion;
                        await tx.mutate.studioConfigVersions.insert({
                            id: crypto.randomUUID(),
                            configID: args.id,
                            version: newVersion,
                            configData: args.configData,
                            createdAt: Date.now(),
                        });
                    }
                }
                await tx.mutate.studioConfigs.update(updates);
            }),
            delete: defineProjectMutator(deleteStudioConfigInputSchema, async ({ tx, ctx, args, }) => {
                assertAdminDataWriteAccess(ctx);
                const versions = await tx.run(projectZql.studioConfigVersions.where("configID", args.id));
                for (const version of versions ?? []) {
                    await tx.mutate.studioConfigVersions.delete({ id: version.id });
                }
                await tx.mutate.studioConfigs.delete({ id: args.id });
            }),
            restoreVersion: defineProjectMutator(restoreStudioConfigVersionInputSchema, async ({ tx, ctx, args, }) => {
                assertAdminDataWriteAccess(ctx);
                const version = await tx.run(projectZql.studioConfigVersions.where("id", args.versionID).one());
                if (!version)
                    throw new Error("Config version not found");
                const current = await tx.run(projectZql.studioConfigs.where("id", args.configID).one());
                if (!current)
                    throw new Error("Studio config not found");
                const newVersion = (current.version ?? 1) + 1;
                await tx.mutate.studioConfigVersions.insert({
                    id: crypto.randomUUID(),
                    configID: args.configID,
                    version: newVersion,
                    configData: version.configData,
                    createdAt: Date.now(),
                });
                await tx.mutate.studioConfigs.update({
                    id: args.configID,
                    configData: version.configData,
                    version: newVersion,
                    updatedAt: Date.now(),
                });
            }),
        },
        studioConnections: {
            create: defineProjectMutator(createStudioConnectionInputSchema, async ({ tx, ctx, args, }) => {
                assertAdminDataWriteAccess(ctx);
                const now = Date.now();
                await tx.mutate.studioConnections.insert({
                    id: args.id,
                    studioID: args.studioID,
                    name: args.name,
                    connectionType: args.connectionType,
                    host: args.host,
                    port: args.port ?? null,
                    model: args.model ?? null,
                    managementURL: args.managementURL ?? null,
                    enabled: args.enabled ?? true,
                    createdAt: now,
                    updatedAt: now,
                });
            }),
            update: defineProjectMutator(updateStudioConnectionInputSchema, async ({ tx, ctx, args, }) => {
                assertAdminDataWriteAccess(ctx);
                await tx.mutate.studioConnections.update({
                    ...args,
                    ...(args.port !== undefined ? { port: args.port ?? null } : {}),
                    ...(args.model !== undefined ? { model: args.model ?? null } : {}),
                    ...(args.managementURL !== undefined
                        ? { managementURL: args.managementURL ?? null }
                        : {}),
                    updatedAt: Date.now(),
                });
            }),
            delete: defineProjectMutator(deleteStudioConnectionInputSchema, async ({ tx, ctx, args, }) => {
                assertAdminDataWriteAccess(ctx);
                await tx.mutate.studioConnections.delete({ id: args.id });
                const configs = await tx.run(projectZql.studioConfigs.where("studioID", args.studioID));
                for (const config of configs ?? []) {
                    const configData = (config.configData ?? emptyStudioConfigData);
                    const nextDeviceStates = Object.fromEntries(Object.entries(configData.device_states ?? {}).filter(([connectionID]) => connectionID !== args.id));
                    const nextPhysicalConnections = (configData.physical_connections ?? []).filter((connection) => connection.source_connection_id !== args.id &&
                        connection.dest_connection_id !== args.id);
                    await tx.mutate.studioConfigs.update({
                        id: config.id,
                        configData: {
                            ...configData,
                            ...(Object.keys(nextDeviceStates).length > 0
                                ? { device_states: nextDeviceStates }
                                : { device_states: undefined }),
                            ...(nextPhysicalConnections.length > 0
                                ? { physical_connections: nextPhysicalConnections }
                                : { physical_connections: undefined }),
                        },
                        updatedAt: Date.now(),
                    });
                }
            }),
        },
        brokers: {
            create: defineProjectMutator(createBrokerInputSchema, async ({ tx, ctx, args, }) => {
                assertAdminDataWriteAccess(ctx);
                await tx.mutate.brokers.insert({
                    ...args,
                    config: args.config ?? {},
                    enabled: args.enabled ?? true,
                });
            }),
            update: defineProjectMutator(updateBrokerInputSchema, async ({ tx, ctx, args, }) => {
                assertAdminDataWriteAccess(ctx);
                await tx.mutate.brokers.update(args);
            }),
            delete: defineProjectMutator(deleteBrokerInputSchema, async ({ tx, ctx, args, }) => {
                assertAdminDataWriteAccess(ctx);
                const outputs = await tx.run(projectZql.brokerOutputs.where("brokerID", args.id));
                for (const output of outputs ?? []) {
                    await tx.mutate.brokerOutputs.delete({ id: output.id });
                }
                await tx.mutate.brokers.delete({ id: args.id });
            }),
        },
        brokerOutputs: {
            create: defineProjectMutator(createBrokerOutputInputSchema, async ({ tx, ctx, args, }) => {
                assertAdminDataWriteAccess(ctx);
                await tx.mutate.brokerOutputs.insert({
                    ...args,
                    config: args.config ?? {},
                    enabled: args.enabled ?? true,
                    sortOrder: args.sortOrder ?? 0,
                });
            }),
            update: defineProjectMutator(updateBrokerOutputInputSchema, async ({ tx, ctx, args, }) => {
                assertAdminDataWriteAccess(ctx);
                await tx.mutate.brokerOutputs.update(args);
            }),
            delete: defineProjectMutator(deleteBrokerOutputInputSchema, async ({ tx, ctx, args, }) => {
                assertAdminDataWriteAccess(ctx);
                await tx.mutate.brokerOutputs.delete({ id: args.id });
            }),
        },
        profiles: {
            create: defineProjectMutator(createProfileInputSchema, async ({ tx, ctx, args, }) => {
                assertAdminDataWriteAccess(ctx);
                await tx.mutate.profiles.insert({
                    ...args,
                    config: args.config ?? {},
                });
            }),
            update: defineProjectMutator(updateProfileInputSchema, async ({ tx, ctx, args, }) => {
                assertAdminDataWriteAccess(ctx);
                await tx.mutate.profiles.update(args);
            }),
            delete: defineProjectMutator(profileIDInputSchema, async ({ tx, ctx, args, }) => {
                assertAdminDataWriteAccess(ctx);
                await tx.mutate.profiles.delete({ id: args.id });
            }),
        },
        streams: {
            create: defineProjectMutator(createStreamInputSchema, async ({ tx, ctx, args, }) => {
                await assertProjectWriteAccess(tx, ctx, args.projectID);
                await tx.mutate.streams.insert({
                    ...args,
                    encoderConfig: args.encoderConfig ?? {},
                    enabled: args.enabled ?? true,
                    lifecycleState: args.lifecycleState ?? "draft",
                    lifecycleError: args.lifecycleError ?? null,
                    provisionedResources: args.provisionedResources ?? null,
                });
            }),
            update: defineProjectMutator(updateStreamInputSchema, async ({ tx, ctx, args, }) => {
                await assertProjectWriteAccess(tx, ctx, args.projectID);
                await tx.mutate.streams.update(args);
            }),
            delete: defineProjectMutator(deleteStreamInputSchema, async ({ tx, ctx, args, }) => {
                await assertProjectWriteAccess(tx, ctx, args.projectID);
                const [audioPairs, outputs, links] = await Promise.all([
                    tx.run(projectZql.streamAudioPairs.where("streamID", args.id)),
                    tx.run(projectZql.streamOutputs.where("streamID", args.id)),
                    tx.run(projectZql.streamBrokers.where("streamID", args.id)),
                ]);
                for (const pair of audioPairs ?? []) {
                    await tx.mutate.streamAudioPairs.delete({ id: pair.id });
                }
                for (const output of outputs ?? []) {
                    await tx.mutate.streamOutputs.delete({ id: output.id });
                }
                for (const link of links ?? []) {
                    await tx.mutate.streamBrokers.delete({ id: link.id });
                }
                await tx.mutate.streams.delete({ id: args.id });
            }),
        },
        streamAudioPairs: {
            create: defineProjectMutator(createStreamAudioPairInputSchema, async ({ tx, ctx, args, }) => {
                await assertStreamWriteAccess(tx, ctx, args.streamID);
                await tx.mutate.streamAudioPairs.insert({
                    ...args,
                    sourceConfig: args.sourceConfig ?? {},
                });
            }),
            delete: defineProjectMutator(deleteStreamAudioPairInputSchema, async ({ tx, ctx, args, }) => {
                await assertStreamWriteAccess(tx, ctx, args.streamID);
                await tx.mutate.streamAudioPairs.delete({ id: args.id });
            }),
        },
        streamOutputs: {
            create: defineProjectMutator(createStreamOutputInputSchema, async ({ tx, ctx, args, }) => {
                await assertStreamWriteAccess(tx, ctx, args.streamID);
                await tx.mutate.streamOutputs.insert({
                    ...args,
                    config: args.config ?? {},
                    enabled: args.enabled ?? true,
                    sortOrder: args.sortOrder ?? 0,
                });
            }),
            update: defineProjectMutator(updateStreamOutputInputSchema, async ({ tx, ctx, args, }) => {
                await assertStreamWriteAccess(tx, ctx, args.streamID);
                await tx.mutate.streamOutputs.update(args);
            }),
            delete: defineProjectMutator(deleteStreamOutputInputSchema, async ({ tx, ctx, args, }) => {
                await assertStreamWriteAccess(tx, ctx, args.streamID);
                await tx.mutate.streamOutputs.delete({ id: args.id });
            }),
        },
        streamBrokers: {
            create: defineProjectMutator(createStreamBrokerInputSchema, async ({ tx, ctx, args, }) => {
                await assertStreamWriteAccess(tx, ctx, args.streamID);
                await tx.mutate.streamBrokers.insert({
                    ...args,
                    enabled: args.enabled ?? true,
                    sortOrder: args.sortOrder ?? 0,
                });
            }),
            update: defineProjectMutator(updateStreamBrokerInputSchema, async ({ tx, ctx, args, }) => {
                await assertStreamWriteAccess(tx, ctx, args.streamID);
                await tx.mutate.streamBrokers.update(args);
            }),
            delete: defineProjectMutator(deleteStreamBrokerInputSchema, async ({ tx, ctx, args, }) => {
                await assertStreamWriteAccess(tx, ctx, args.streamID);
                await tx.mutate.streamBrokers.delete({ id: args.id });
            }),
        },
        projectAwsResourceLinks: {
            create: defineProjectMutator(createProjectAwsResourceLinkInputSchema, async ({ tx, ctx, args, }) => {
                await assertProjectWriteAccess(tx, ctx, args.projectID);
                await tx.mutate.projectAwsResourceLinks.insert({
                    id: args.id,
                    projectID: args.projectID,
                    resourceType: args.resourceType,
                    resourceID: args.resourceID ?? null,
                    resourceArn: args.resourceArn ?? null,
                    resourceName: args.resourceName ?? null,
                    metadata: args.metadata ?? {},
                });
            }),
            update: defineProjectMutator(updateProjectAwsResourceLinkInputSchema, async ({ tx, ctx, args, }) => {
                await assertProjectWriteAccess(tx, ctx, args.projectID);
                await tx.mutate.projectAwsResourceLinks.update({
                    ...args,
                    ...(args.resourceID !== undefined
                        ? { resourceID: args.resourceID ?? null }
                        : {}),
                    ...(args.resourceArn !== undefined
                        ? { resourceArn: args.resourceArn ?? null }
                        : {}),
                    ...(args.resourceName !== undefined
                        ? { resourceName: args.resourceName ?? null }
                        : {}),
                    ...(args.metadata !== undefined
                        ? { metadata: args.metadata ?? {} }
                        : {}),
                });
            }),
            delete: defineProjectMutator(deleteProjectAwsResourceLinkInputSchema, async ({ tx, ctx, args, }) => {
                await assertProjectWriteAccess(tx, ctx, args.projectID);
                await tx.mutate.projectAwsResourceLinks.delete({ id: args.id });
            }),
        },
        streamAudioFeeds: {
            create: defineProjectMutator(createStreamAudioFeedInputSchema, async ({ tx, ctx, args, }) => {
                await assertProjectWriteAccess(tx, ctx, args.projectID);
                await tx.mutate.streamAudioFeeds.insert({
                    ...args,
                    sortOrder: args.sortOrder ?? 0,
                });
            }),
            delete: defineProjectMutator(deleteStreamAudioFeedInputSchema, async ({ tx, ctx, args, }) => {
                await assertProjectWriteAccess(tx, ctx, args.projectID);
                await tx.mutate.streamAudioFeeds.delete({ id: args.id });
            }),
            update: defineProjectMutator(updateStreamAudioFeedInputSchema, async ({ tx, ctx, args, }) => {
                await assertProjectWriteAccess(tx, ctx, args.projectID);
                await tx.mutate.streamAudioFeeds.update(args);
            }),
        },
        streamVideoFeeds: {
            create: defineProjectMutator(createStreamVideoFeedInputSchema, async ({ tx, ctx, args, }) => {
                await assertProjectWriteAccess(tx, ctx, args.projectID);
                await tx.mutate.streamVideoFeeds.insert({
                    ...args,
                    description: args.description ?? "",
                    sortOrder: args.sortOrder ?? 0,
                });
            }),
            delete: defineProjectMutator(deleteStreamVideoFeedInputSchema, async ({ tx, ctx, args, }) => {
                await assertProjectWriteAccess(tx, ctx, args.projectID);
                await tx.mutate.streamVideoFeeds.delete({ id: args.id });
            }),
            update: defineProjectMutator(updateStreamVideoFeedInputSchema, async ({ tx, ctx, args, }) => {
                await assertProjectWriteAccess(tx, ctx, args.projectID);
                await tx.mutate.streamVideoFeeds.update(args);
            }),
        },
        streamSignals: {
            create: defineProjectMutator(createStreamSignalInputSchema, async ({ tx, ctx, args, }) => {
                await assertProjectWriteAccess(tx, ctx, args.projectID);
                await tx.mutate.streamSignals.insert({
                    ...args,
                    name: args.name ?? "",
                    description: args.description ?? "",
                    videoFeedID: args.videoFeedID ?? null,
                    sortOrder: args.sortOrder ?? 0,
                });
            }),
            delete: defineProjectMutator(deleteStreamSignalInputSchema, async ({ tx, ctx, args, }) => {
                await assertProjectWriteAccess(tx, ctx, args.projectID);
                const links = await tx.run(projectZql.streamSignalAudioFeeds.where("signalID", args.id));
                for (const link of links ?? []) {
                    await tx.mutate.streamSignalAudioFeeds.delete({ id: link.id });
                }
                await tx.mutate.streamSignals.delete({ id: args.id });
            }),
            update: defineProjectMutator(updateStreamSignalInputSchema, async ({ tx, ctx, args, }) => {
                await assertProjectWriteAccess(tx, ctx, args.projectID);
                await tx.mutate.streamSignals.update(args);
            }),
        },
        streamSignalAudioFeeds: {
            create: defineProjectMutator(createStreamSignalAudioFeedInputSchema, async ({ tx, ctx, args, }) => {
                const signal = await tx.run(projectZql.streamSignals.where("id", args.signalID).one());
                if (!signal)
                    throw new Error("Signal not found");
                await assertProjectWriteAccess(tx, ctx, signal.projectID);
                await tx.mutate.streamSignalAudioFeeds.insert({
                    ...args,
                    sortOrder: args.sortOrder ?? 0,
                });
            }),
            update: defineProjectMutator(updateStreamSignalAudioFeedInputSchema, async ({ tx, ctx, args, }) => {
                const signal = await tx.run(projectZql.streamSignals.where("id", args.signalID).one());
                if (!signal)
                    throw new Error("Signal not found");
                await assertProjectWriteAccess(tx, ctx, signal.projectID);
                await tx.mutate.streamSignalAudioFeeds.update(args);
            }),
            delete: defineProjectMutator(deleteStreamSignalAudioFeedInputSchema, async ({ tx, ctx, args, }) => {
                const signal = await tx.run(projectZql.streamSignals.where("id", args.signalID).one());
                if (!signal)
                    throw new Error("Signal not found");
                await assertProjectWriteAccess(tx, ctx, signal.projectID);
                await tx.mutate.streamSignalAudioFeeds.delete({ id: args.id });
            }),
        },
        streamTakers: {
            create: defineProjectMutator(createStreamTakerInputSchema, async ({ tx, ctx, args, }) => {
                await assertProjectWriteAccess(tx, ctx, args.projectID);
                await tx.mutate.streamTakers.insert({
                    ...args,
                    deliveryMethod: args.deliveryMethod ?? "",
                    url: args.url ?? "",
                    signalID: args.signalID ?? null,
                    contact: args.contact ?? "",
                    notes: args.notes ?? "",
                    testDate: args.testDate ?? null,
                    tested: args.tested ?? false,
                    preTestDone: args.preTestDone ?? false,
                    onDayTestDone: args.onDayTestDone ?? false,
                });
            }),
            update: defineProjectMutator(updateStreamTakerInputSchema, async ({ tx, ctx, args, }) => {
                await assertProjectWriteAccess(tx, ctx, args.projectID);
                await tx.mutate.streamTakers.update(args);
            }),
            delete: defineProjectMutator(deleteStreamTakerInputSchema, async ({ tx, ctx, args, }) => {
                await assertProjectWriteAccess(tx, ctx, args.projectID);
                const pairs = await tx.run(projectZql.streamTakerAudioPairs.where("streamTakerID", args.id));
                for (const pair of pairs ?? []) {
                    await tx.mutate.streamTakerAudioPairs.delete({ id: pair.id });
                }
                const contacts = await tx.run(projectZql.streamTakerContacts.where("streamTakerID", args.id));
                for (const c of contacts ?? []) {
                    await tx.mutate.streamTakerContacts.delete({ id: c.id });
                }
                const tests = await tx.run(projectZql.streamTakerAudioPairTests.where("streamTakerID", args.id));
                for (const t of tests ?? []) {
                    await tx.mutate.streamTakerAudioPairTests.delete({ id: t.id });
                }
                await tx.mutate.streamTakers.delete({ id: args.id });
            }),
        },
        streamTakerAudioPairs: {
            create: defineProjectMutator(createStreamTakerAudioPairInputSchema, async ({ tx, ctx, args, }) => {
                await assertStreamTakerWriteAccess(tx, ctx, args.streamTakerID);
                await tx.mutate.streamTakerAudioPairs.insert({
                    ...args,
                    audioFeedID: args.audioFeedID ?? null,
                });
            }),
            update: defineProjectMutator(updateStreamTakerAudioPairInputSchema, async ({ tx, ctx, args, }) => {
                await assertStreamTakerWriteAccess(tx, ctx, args.streamTakerID);
                await tx.mutate.streamTakerAudioPairs.update(args);
            }),
            delete: defineProjectMutator(deleteStreamTakerAudioPairInputSchema, async ({ tx, ctx, args, }) => {
                await assertStreamTakerWriteAccess(tx, ctx, args.streamTakerID);
                await tx.mutate.streamTakerAudioPairs.delete({ id: args.id });
            }),
        },
        streamTakerContacts: {
            create: defineProjectMutator(createStreamTakerContactInputSchema, async ({ tx, ctx, args, }) => {
                await assertStreamTakerWriteAccess(tx, ctx, args.streamTakerID);
                await tx.mutate.streamTakerContacts.insert({
                    ...args,
                    description: args.description ?? "",
                });
            }),
            update: defineProjectMutator(updateStreamTakerContactInputSchema, async ({ tx, ctx, args, }) => {
                await assertStreamTakerWriteAccess(tx, ctx, args.streamTakerID);
                await tx.mutate.streamTakerContacts.update(args);
            }),
            delete: defineProjectMutator(deleteStreamTakerContactInputSchema, async ({ tx, ctx, args, }) => {
                await assertStreamTakerWriteAccess(tx, ctx, args.streamTakerID);
                await tx.mutate.streamTakerContacts.delete({ id: args.id });
            }),
        },
        streamTakerAudioPairTests: {
            create: defineProjectMutator(createStreamTakerAudioPairTestInputSchema, async ({ tx, ctx, args, }) => {
                await assertStreamTakerWriteAccess(tx, ctx, args.streamTakerID);
                await tx.mutate.streamTakerAudioPairTests.insert({
                    ...args,
                    tested: args.tested ?? false,
                    preTestDone: args.preTestDone ?? false,
                    onDayTestDone: args.onDayTestDone ?? false,
                });
            }),
            update: defineProjectMutator(updateStreamTakerAudioPairTestInputSchema, async ({ tx, ctx, args, }) => {
                await assertStreamTakerWriteAccess(tx, ctx, args.streamTakerID);
                await tx.mutate.streamTakerAudioPairTests.update(args);
            }),
            delete: defineProjectMutator(deleteStreamTakerAudioPairTestInputSchema, async ({ tx, ctx, args, }) => {
                await assertStreamTakerWriteAccess(tx, ctx, args.streamTakerID);
                await tx.mutate.streamTakerAudioPairTests.delete({ id: args.id });
            }),
        },
    };
}
